const md = `
### Select, join, and transform data on demand with no coding required

Combine datasets from multiple sources and get clean output ready for your analysis with just a few clicks.
`;

export default md;
